function isElement(node) {
    var ELEMENT_NODE_TYPE = 1;
    return node.tagName !== 'HTML' && node.tagName !== 'BODY' && node.nodeType !== ELEMENT_NODE_TYPE;
}
export function getScrollParent(el, root) {
    if (root === void 0) { root = window; }
    var node = el;
    while (node && node !== root && isElement(node)) {
        var overflowY = window.getComputedStyle(node).overflowY;
        if (/scroll|auto/i.test(overflowY)) {
            return node;
        }
        node = node.parentNode;
    }
    return root;
}
